import React from "react";
import styled, { css } from "styled-components";
import { IconController } from "../../Scripts/ImgController";
import Ripples from "react-ripples";

const Wrapper = styled.div`
  width: 100%;
  ${(props) =>
    props.type === "mkaraoke"
      ? css`
          :hover {
            background: linear-gradient(
              270deg,
              rgba(255, 255, 255, 0.45) 0%,
              rgba(255, 255, 255, 0) 100%
            );
          }
        `
      : css`
          :hover {
            background: linear-gradient(
              270deg,
              rgba(0, 97, 255, 0.45) 0%,
              rgba(0, 97, 255, 0) 100%
            );
          }
        `}
`;

const ToggleSidebarMenu = ({
  icon,
  title,
  sidebarExpanded,
  type = "music",
}) => {

  return (
    <Ripples color="#ffffff40" during={600} className="w-full">
      <Wrapper type={type}>
        <a href={`${type === "music" ? "/karaoke":"/music"}`}>
        <div
          className={`w-full py-4 px-8 text-white flex flex-row items-center cursor-pointer`}
        >
          <IconController src={icon} alt="" className="w-5 h-5" />
          <h5
            className={`title text-sm origin-left duration-200 ${
              sidebarExpanded ? "pl-3" : "hidden"
            }`}
          >
            {title}
          </h5>
        </div>
        </a>
      </Wrapper>
    </Ripples>
  );
};

export default ToggleSidebarMenu;
